import React from 'react';
import { i18n } from 'config/locales';
import { IDENTIFICATION, IDENTIFICATION_BIRTH_PLACE } from 'config/formSections/identification';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import Field from 'components/Form/Field';
import Location from 'components/Form/Location';
import PVQLocation from 'components/Form/PVQLocation';
import { isPVQForm } from 'helpers/form';
import PVQName from 'components/Form/PVQName';

const sectionConfig = {
  key: IDENTIFICATION_BIRTH_PLACE.key,
  section: IDENTIFICATION.name,
  store: IDENTIFICATION.store,
  subsection: IDENTIFICATION_BIRTH_PLACE.name,
  storeKey: IDENTIFICATION_BIRTH_PLACE.storeKey,
};

export class ApplicantBirthPlace extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;

    this.update = this.update.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.updateMothersNameAtHerBirth = this.updateMothersNameAtHerBirth.bind(this);
    this.updateMothersNameAtYourBirth = this.updateMothersNameAtYourBirth.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  getEmptyName = () => ({
    first: '',
    last: '',
    middle: '',
    suffix: '',
    suffixOther: '',
    firstInitialOnly: false,
    noFirstName: false,
    hideNoFirstName: false,
    hideMiddleName: false,
    middleInitialOnly: false,
    noMiddleName: false,
    firstLettersOnly: false,
    middleLettersOnly: false,
    lastLettersOnly: false,
    firstUnknown: false,
    middleUnknown: false,
    lastUnknown: false,
  });

  update(queue) {
    this.props.onUpdate(this.storeKey, {
      Location: this.props.Location,
      MothersNameAtHerBirth: this.props.MothersNameAtHerBirth,
      MothersNameAtYourBirth: this.props.MothersNameAtYourBirth,
      ...queue,
    });
  }

  updateLocation(values) {
    this.update({
      Location: values,
      MothersNameAtHerBirth: values.inUSA === false ? this.getEmptyName() : this.props.MothersNameAtHerBirth,
      MothersNameAtYourBirth: values.inUSA === false ? this.getEmptyName() : this.props.MothersNameAtYourBirth,
    });
  }

  updateMothersNameAtHerBirth(values) {
    this.update({
      MothersNameAtHerBirth: values,
    });
  }

  updateMothersNameAtYourBirth(values) {
    this.update({
      MothersNameAtYourBirth: values,
    });
  }

  render() {
    const klass = `section-content applicant-birthplace ${this.props.className || ''}`.trim();
    const isPVQ = isPVQForm(this.props.formType);

    return isPVQ ? (
      <div
        className={klass}
        data-section={IDENTIFICATION.key}
        data-subsection={IDENTIFICATION_BIRTH_PLACE.key}
      >
        <h1 className="section-header">{i18n.t('identification.pvq.destination.birthplace')}</h1>
        <label className="birthplace-label">{i18n.m('identification.pvq.birthplace.info')}</label>
        <Field
          title={i18n.t('identification.pvq.birthplace.title')}
          scrollIntoView={this.props.scrollIntoView}
          attribute="Location"
          className="no-margin-bottom"
          exactAttribute
        >
          <PVQLocation
            attribute="Location"
            name="birthplace"
            {...this.props.Location}
            layout={Location.IDENTIFICATION_BIRTH_PLACE}
            stateLabel={i18n.t('identification.pvq.birthplace.label.state')}
            cityLabel={i18n.t('identification.pvq.birthplace.label.city')}
            countyLabel={i18n.t('identification.pvq.birthplace.label.county')}
            countryLabel={i18n.t('identification.pvq.birthplace.label.country')}
            domesticTitle={i18n.t('identification.pvq.birthplace.label.sub')}
            foreignTitle={i18n.t('identification.pvq.birthplace.label.sub')}
            onUpdate={this.updateLocation} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError}
            required={this.props.required}
          />
        </Field>

        <div style={{ height: '50px' }} />
        <Field
          title={i18n.t('identification.pvq.birthplace.label.mothersNameAtHerBirth')}
          titleSize="h4"
          scrollIntoView={this.props.scrollIntoView}
          attribute="MothersNameAtHerBirth"
        >
          <PVQName
            name="name"
            {...this.props.MothersNameAtHerBirth}
            aria-label="Provide your full name"
            onUpdate={this.updateMothersNameAtHerBirth} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            textPrefix="birthplace.mothersName"
            prefix="name"
            attribute="MothersNameAtHerBirth"
            showLastFirstMiddleNameOrder
          />
        </Field>
        <Field
          title={i18n.t('identification.pvq.birthplace.label.mothersNameAtYourBirth')}
          titleSize="h4"
          scrollIntoView={this.props.scrollIntoView}
          attribute="MothersNameAtYourBirth"
        >
          <PVQName
            {...this.props.MothersNameAtYourBirth}
            aria-label="Provide your full name"
            onUpdate={this.updateMothersNameAtYourBirth} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            textPrefix="birthplace.mothersName"
            prefix="name"
            attribute="MothersNameAtYourBirth"
            showLastFirstMiddleNameOrder
          />
        </Field>
      </div>
    ) : (
      <div
        className={klass}
        data-section={IDENTIFICATION.key}
        data-subsection={IDENTIFICATION_BIRTH_PLACE.key}
      >
        <h1 className="section-header">{i18n.t('identification.destination.birthplace')}</h1>
        <Field
          title={i18n.t('identification.birthplace.title')}
          titleSize="h4"
          scrollIntoView={this.props.scrollIntoView}
          attribute="Location"
        >
          <Location
            attribute="Location"
            name="birthplace"
            {...this.props.Location}
            layout={Location.IDENTIFICATION_BIRTH_PLACE}
            stateLabel={i18n.t('identification.birthplace.label.state')}
            cityLabel={i18n.t('identification.birthplace.label.city')}
            countyLabel={i18n.t('identification.birthplace.label.county')}
            countryLabel={i18n.t('identification.birthplace.label.country')}
            onUpdate={this.updateLocation} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError}
            required={this.props.required}
          />
        </Field>
      </div>
    );
  }
}

ApplicantBirthPlace.defaultProps = {
  Location: {},
  MothersNameAtHerBirth: {},
  MothersNameAtYourBirth: {},
  onUpdate: () => { },
  onError: (value, arr) => arr,
  dispatch: () => { },
};

ApplicantBirthPlace.errors = [];

export default connectSubsection(ApplicantBirthPlace, sectionConfig);
